module.exports = __webpack_public_path__ + "static/media/stop.3c50c09b.svg";